//导出excel
import moment from "moment";
export const excelExport = (columns, excelData) => {

  var columnNames = []
  var columnValues = []
  for (var i = 0; i < columns.length; i++) {
    if (columns[i].title == '操作') {

    }
    else {
      columnNames[i] = columns[i].title
      columnValues[i] = columns[i].key
    }

  }
  require.ensure([], () => {
    const {
      export_json_to_excel
    } = require('@/vendor/Export2Excel') // 这里必须使用绝对路径
    const tHeader = columnNames // ['表头名称1', '表头名称2', '表头名称3'] // 导出的表头名信息
    const filterVal = columnValues //['name', 'age', 'address'] // 导出的表头字段名，需要导出表格字段名
    const list = excelData
    const data = formatJson(filterVal, list)
    export_json_to_excel(tHeader, data, '导出表格数据' + moment().format('yyyy-MM-dd HH:mm:ss')) // 导出的表格名称，根据需要自己命名
  })
}
// 格式转换，直接复制即可
function formatJson(filterVal, jsonData) {
  return jsonData.map((v) => filterVal.map((j) => v[j]))
}